import { device } from 'utils/device';
export class Inertia {
	public active: boolean = true;
	public value: number = 0;
	public target: number = 0;
	private _easeTarget: number = 0;
	private _easeFrameUpdate: number = 0.1;
	private _diff: number = 0;
	private _diffUpdate: number;
	private _easeLerpingActive: boolean = false;
	private _lerpChangePerFrame: number;
	private _lerpFramesToProcess: number;

	private _vectorBased: boolean = false;
	private _vectorIncreaseRate: number = 0.001;
	private _maxVectorForce: number = 0.2;
	private _vectorForce: number = 0;
	private _reduceForceAt: number = 2;
	private _dampen: number = 0.87;

	constructor(
		public ease: number,
		value: number = 0
	) {
		this.value = value;
		if (this.value) {
			this.target = this.value;
		}
	}

	//GETTER / SETTER
	//----------------------------------------------------------------------------

	public set easeTarget(value: number) {
		this._easeTarget = value;
	}

	public set easeFrameUpdate(value: number) {
		this._easeFrameUpdate = value;
	}

	//PUBLIC METHODS
	//-----------------------------------------------------------------------------

	public setVectorConfig(active: boolean, increaseRate: number = 0.3, maxForce: number = 3, dampen = 0.87) {
		//How much smaller is  this from 1920.....
		const r = 1 - Math.min(1, device.innerWidth / 1600);

		this._vectorBased = active;
		this._vectorIncreaseRate = (increaseRate - increaseRate * 0.6 * r) * (0.5 + Math.random() * 0.5);
		this._maxVectorForce = (maxForce - maxForce * 0.5 * r) * (0.5 + Math.random() * 0.5);

		//Reduce affect based on size:
		this._dampen = dampen;

		this._reduceForceAt = 1 - r * 0.3;


	}

	public setVectorFast() {

		this._vectorBased = true;
		this._vectorIncreaseRate = 0.3 + Math.random() * 0.4;
		this._maxVectorForce = 1.5 + Math.random() * 1.9;
		this._dampen = 0.98;
		this._reduceForceAt = 4;
	}

	public setEase(easeValue: number): void {
		this.resetEaseLerp();
		this.ease = easeValue;
	}

	public tick(): void {
		if (!this.active) {
			return;
		}

		if (this._vectorBased) {
			this._processVector();
			return;
		}

		if (this._easeLerpingActive) {
			this.ease += this._lerpChangePerFrame;
			this._lerpFramesToProcess--;
			if (this._lerpFramesToProcess <= 0) {
				this.resetEaseLerp();
			}
		}

		if (this._easeTarget !== 0 && this._easeTarget !== this.ease) {
			this._diff = this._easeTarget - this.ease;
			this._diffUpdate =
				this._diff > 0 ? Math.min(this._diff, this._easeFrameUpdate) : Math.max(this._diff, -this._easeFrameUpdate);
			this.ease += this._diffUpdate;
		}

		if (this.active) {
			this.value = this.value + ((this.target - this.value) / this.ease) * (window as any).deltaTime;
		}
	}

	public resetEaseLerp() {
		this._easeLerpingActive = false;
		this._lerpChangePerFrame = null;
		this._lerpFramesToProcess = null;
	}

	public lerpEase(targetEase: number, frames: number) {
		const diff = targetEase - this.ease;

		if (diff === 0) {
			return;
		}

		this._easeLerpingActive = true;
		this._lerpChangePerFrame = diff / frames;
		this._lerpFramesToProcess = frames;
	}

	private _processVector() {
		const d = this.target - this.value;

		if (Math.abs(d) > 10) {
			this._vectorForce +=
				d > 0
					? this._vectorIncreaseRate * (window as any).deltaTime
					: -1 * this._vectorIncreaseRate * (window as any).deltaTime;
		}

		if (Math.abs(d) < this._reduceForceAt) {
			this._vectorForce *= this._dampen;
		}

		this._vectorForce = Math.max(-1 * this._maxVectorForce, Math.min(this._vectorForce, this._maxVectorForce));

		this.value += this._vectorForce * (window as any).deltaTime;
	}
}
